class BundledProductValidator {
  constructor(bundledProduct) {
    this.bundledProduct = bundledProduct;
  }

  priceTooHigh() {
    return parseFloat(this.bundledProduct.listing.price.amount) > parseFloat(this.bundledProduct.listing.original_price.amount);
  }

  validate() {
    if (!(this.bundledProduct.listing.price && this.bundledProduct.listing.price.amount)) {
      this.bundledProduct.errorMessage = I18n.t('js.productBundles.bundleInfoForm.errors.noPrice');
    } else if (this.priceTooHigh()) {
      this.bundledProduct.errorMessage = I18n.t('js.productBundles.bundleInfoForm.errors.priceTooHigh');
    } else {
      this.bundledProduct.errorMessage = null;
    }
  }
}

export default BundledProductValidator;



// WEBPACK FOOTER //
// ./javascripts/components/product_bundles/bundled_product_validator.js